import api from './api';

export const restaurantService = {
  // Get restaurant configuration for admin panel
  getRestaurantConfig: async () => {
    try {
      const response = await api.get('/restaurants/');
      return response.data;
    } catch (error) {
      console.error('Error fetching restaurant config:', error);
      throw error;
    }
  },

  // Update restaurant configuration
  updateRestaurantConfig: async (configData) => {
    try {
      const response = await api.put('/restaurants/', configData);
      return response.data;
    } catch (error) {
      console.error('Error updating restaurant config:', error);
      throw error;
    }
  },

  // Upload restaurant image (logo or cover)
  uploadRestaurantImage: async (imageType, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.post(`/restaurants/upload-image/${imageType}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error uploading ${imageType} image:`, error);
      throw error;
    }
  },

  // Get public restaurant data (for homepage)
  getPublicRestaurantData: async () => {
    try {
      const response = await api.get('/public/restaurant');
      console.log("Yes Here ")
      return response.data;
    } catch (error) {
      console.error('Error fetching public restaurant data:', error);
      throw error;
    }
  },

  // Get public categories
  getPublicCategories: async () => {
    try {
      const response = await api.get('/public/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // Get public menu items (optionally by category)
  getPublicMenuItems: async (params = {}) => {
    try {
      const response = await api.get('/public/menu-items', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching menu items:', error);
      throw error;
    }
  },

  // Get restaurant statistics
  getRestaurantStats: async () => {
    try {
      const response = await api.get('/public/restaurant/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching restaurant stats:', error);
      throw error;
    }
  },

  // Get dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      throw error;
    }
  },

  // Get public outlets
  getPublicOutlets: async (serviceType = null) => {
    try {
      const params = serviceType ? { service_type: serviceType } : {};
      const response = await api.get('/public/outlets', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching outlets:', error);
      throw error;
    }
  },

  // Get public slider images
  getPublicSliderImages: async () => {
    try {
      const response = await api.get('/public/slider-images');
      console.log('Slider images API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching slider images:', error);
      // Return empty array instead of throwing error to prevent app crash
      return [];
    }
  }
};
